import * as Sentry from '@sentry/react';
import {
  ENVIRONMENT,
  isProdInstance,
  isUatInstance,
  SENTRY_DSN
} from './settings';

const SentryIntegrations = [Sentry.browserTracingIntegration()];
if (isProdInstance || isUatInstance) {
  SentryIntegrations.push(Sentry.replayIntegration());
}

Sentry.init({
  dsn: SENTRY_DSN,
  environment: ENVIRONMENT,
  ignoreErrors: [
    'Non-Error exception captured',
    'Non-Error promise rejection captured'
  ],
  integrations: SentryIntegrations,
  tracePropagationTargets: [/^\//, '*'],
  replaysSessionSampleRate: 0.1,
  tracesSampleRate: 1.0
});
